<div class="dialog-panel message-dialog" [ngStyle]="{ 'border-radius': borderRadius }">
  <div
    class="icon-close"
    [inlineSVG]="closeIconPath ? closeIconPath : '/icons/icon-close-no-color.svg'"
    (click)="closeDialog()"
  ></div>
  <div *ngIf="title" class="dialog-header">
    <h1 class="dialog-title">{{ title }}</h1>
    <span class="page-indicator">{{ pageIndicator }}</span>
  </div>
  <div class="dialog-content" [ngStyle]="{ 'min-height': minHeight }">
    <ng-container *ngTemplateOutlet="content"> </ng-container>
  </div>
  <div class="dialog-actions mt-5">
    <p *ngIf="dialogWarning" class="warning mt-auto">{{ dialogWarning }}</p>

    <ng-container *ngTemplateOutlet="actions || defaultActions"> </ng-container>
  </div>
</div>
<div>
  <ng-template #defaultActions>
    <button [disabled]="disableSubmit" class="Volgende w-100 btn btn-cta" (click)="handleConfirm()">
      <ng-container *ngIf="btnText"> </ng-container>
      {{ btnText || 'global.save' | translate }}
    </button>
  </ng-template>
</div>
